module.exports = __webpack_public_path__ + "img/outpatientPersonCapita.831930b6.svg";